import { InputField, Form } from "@made-people/blueprint-form";
import { ButtonAsButton } from "@made-people/blueprint-button";
import { useTranslate } from "@made-people/grease-translations";
import { useLoginForm } from "../hooks/use-login-form";
import { ErrorMessage } from "./ErrorMessage";

type LoginFormProps = {
  form: ReturnType<typeof useLoginForm>;
  forgotPasswordAction: React.ReactNode;
  signupAction: React.ReactNode;
};

export const LoginForm = ({
  form,
  forgotPasswordAction,
  signupAction,
}: LoginFormProps) => {
  const translate = useTranslate();

  return (
    <div className="flex flex-col gap-6">
      <div className="flex flex-col gap-2 md:gap-4">
        <h2 className="text-heading-sm">
          {translate("Account_Login_Heading")}
        </h2>
        <p className="text-body-md">{translate("Account_Login_Lead")}</p>
      </div>
      <Form>
        <div className="flex flex-col gap-6">
          <InputField
            template="floating-label"
            type="email"
            label={translate("Form_Field_Email")}
            placeholder={translate("Form_Field_Email")}
            value={form.email}
            onChange={(e) => form.setEmail(e.target.value)}
            onKeyDown={form.handleKeyDown}
          />
          <InputField
            template="floating-label"
            type="password"
            label={translate("Form_Field_Password")}
            placeholder={translate("Form_Field_Password")}
            value={form.password}
            onChange={(e) => form.setPassword(e.target.value)}
            onKeyDown={form.handleKeyDown}
          />
          <ErrorMessage error={form.error} />
          <div className="flex justify-end">{forgotPasswordAction}</div>
          <div className="flex flex-col gap-4">
            <ButtonAsButton
              label={translate("Account_Login_PrimaryAction")}
              onClick={form.handleSubmit}
              progress={form.loadingState}
              variants={{ width: "full" }}
            />
            {signupAction}
          </div>
        </div>
      </Form>
    </div>
  );
};
